import * as React from 'react';
import './RecentOrders.scss';
import Button from '../common/Button';
import RecentOrder from './components/RecentOrder';
import { isMd, isLg, isMobile } from 'src/utils/responsiveHelpers';
import { throttle } from 'lodash';
import { goToOrders } from 'src/utils/navigation';
import { IOrders } from 'src/model/modules/orders.model';
import RecentOrderLoading from './components/RecentOrderLoading';
import RecentOrderCarouselContainer from './../RecentOrderCarouselContainer';
import exploreSmall from '../../assets/explore-small';
import { env } from 'src/shared/env';
import { HalfCircleSpinner } from 'react-epic-spinners';

interface IRecentOrdersProps {
  isLoggedIn: boolean;
  recentOrders: IOrders[];
  isLoading: boolean;
  hadError: boolean;
  getRecentOrders: () => void;
  t?: any;
}

interface IRecentOrdersState {
  isMobile: boolean;
}

export class RecentOrders extends React.Component<
  IRecentOrdersProps,
  IRecentOrdersState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      isMobile: isMobile()
    };
  }

  public componentDidMount() {
    if (this.props.isLoggedIn) {
      this.props.getRecentOrders();
    }
  }

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  public handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  private viewAll = () => {
    goToOrders();
  };

  private renderOrdersDesktop() {
    const colClass = isLg() ? 'col-md-3' : 'col-md-3';
    // const noOrdersColClass = isLg() ? 'col-md-12' : 'col-md-12';

    const finalOrderList: any[] = [];
    this.props.recentOrders.forEach(orderObj => {
      orderObj.orderDetails.forEach(order => {
        order.status = orderObj.status;
        order['orderDate'] = orderObj.orderDate;
      });
      finalOrderList.push(...orderObj.orderDetails);
    });
    const placeholders = Array(finalOrderList.length).fill(null);

    function renderLoading() {
      const loaders = Array(finalOrderList).fill(null);
      return (
        <React.Fragment>
          {loaders.map((_, i) => {
            const isLast = loaders.length === i + 1;
            return (
              <div key={i} className={colClass}>
                <RecentOrderLoading showSeparator={!isLast} />
              </div>
            );
          })}
        </React.Fragment>
      );
    }

    const renderNoOrders = () => {
      const { t } = this.props;
      return (
        <React.Fragment>
          <div className="pre-login">
            <div className="recent-orders-no-text">
              {t('common.recentOrders')}
            </div>
            <div className="rp-no-data-container-main rp-recent-orders-no-data-container">
              <div className="rp-no-data-container">
                <div className="rp-no-data-text">
                  <div className="rp-text-container-no-data">
                    <p className="rp-no-data-desc">
                      {t('common.youHaventPurchasedAnything')}
                    </p>
                  </div>
                </div>
                <div className="rp-no-data-image-container">
                  <img
                    className={
                      env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                        ? 'rp-no-data-img rp-no-data-img-CA'
                        : 'rp-no-data-img'
                    }
                    src={exploreSmall}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    };

    const renderOrders = () => {
      const { t } = this.props;
      return this.props.isLoggedIn && this.props.isLoading ? (
        <div className="rp-text-container-no-data text-center">
          <HalfCircleSpinner
            color="#0b4da2"
            size={60}
            style={{
              textAlign: 'center',
              display: 'inline-block'
            }}
          />
          <p className="rp-no-data-desc">Loading...</p>
        </div>
      ) : (
        <div>
          <div className="rp-recent-orders--title">
            {t('common.recentOrders')}
          </div>
          <div className="btn-alignment">
            <Button
              buttonClass="rp-recent-orders--button"
              label={t('recentOrders.viewAll')}
              action={this.viewAll}
            />
          </div>
          <RecentOrderCarouselContainer loading={this.props.isLoading}>
            {finalOrderList.map(
              ({ image, productNumber, orderNumber, orderDate, status }, i) => {
                const isLast = finalOrderList.length === i + 1;
                return (
                  <div key={i}>
                    <RecentOrder
                      image={image}
                      productNo={productNumber}
                      orderNo={orderNumber}
                      date={orderDate}
                      status={status}
                      showSeparator={!isLast}
                    />
                  </div>
                );
              }
            )}
          </RecentOrderCarouselContainer>
        </div>
      );
      // <React.Fragment>
      //   {orders.map(({ orderNumber, orderDate, status }, i) => {
      //     const isLast = orders.length === i + 1;
      //     return (
      //       <div key={i} className={colClass}>
      //         <RecentOrder
      //           orderNo={orderNumber}
      //           date={orderDate}
      //           status={status}
      //           showSeparator={!isLast}
      //         />
      //       </div>
      //     );
      //   })}
      //   {placeholders.map((_, i) => (
      //     <div key={'ph' + i} className={colClass} />
      //   ))}
      // </React.Fragment>
    };

    return (
      <React.Fragment>
        {/* <div className="rp-recent-orders--title">Recent Orders</div>
        <div className="btn-alignment">
          <Button
            buttonClass="rp-recent-orders--button"
            label={'View All'}
            action={this.viewAll}
          />
        </div> */}
        {finalOrderList.length ? renderOrders() : renderNoOrders()}
      </React.Fragment>
    );
  }

  // private renderOrderMobile() {
  //   if (this.props.isLoading) {
  //     return <RecentOrderLoading showSeparator={false} />;
  //   }
  //   if (!this.props.recentOrders.length) {
  //     return <div className="pre-login">No Recent Orders</div>;
  //   }
  //   // Get last order
  //   const { productNumber, orderNumber, orderDate, status } = this.props.recentOrders[0];
  //   return (
  //     <RecentOrder
  //       productNo={productNumber}
  //       orderNo={orderNumber}
  //       date={orderDate}
  //       status={status}
  //       showSeparator={false}
  //     />
  //   );
  // }

  private renderDesktop() {
    const { t } = this.props;
    return (
      // <div className="rp-recent-orders">
      //   <div className="rp-recent-orders--container">
      //     <div className="container-fluid">
      //       <div className="row no-gutters">
      //         {this.props.isLoggedIn ? (
      //           this.renderOrdersDesktop()
      //         ) : (
      //             <div className="col-md-10 pre-login">
      //               View your recent orders in one click
      //             </div>
      //           )}
      //       </div>
      //     </div>
      //   </div>
      // </div>
      <div className="rp-recent-orders">
        {this.props.isLoggedIn ? (
          this.renderOrdersDesktop()
        ) : (
          <div className="pre-login">{t('common.viewRecentOrdersOnClick')}</div>
        )}
      </div>
    );
  }

  // private renderMobile() {
  //   return (
  //     <div className="rp-recent-orders-mobile">
  //       <div className="rp-recent-orders--title">Recent Orders</div>
  //       {this.props.isLoggedIn ? (
  //         <div>
  //           <div className="rp-recent-orders-mobile--order">
  //             <div className="rp-recent-orders-mobile--span rp-recent-orders-mobile--span-separator">
  //               <span className="rp-recent-orders--separator" />
  //             </div>
  //             <div className="rp-recent-orders-mobile--span rp-recent-orders-mobile--span-order">
  //               {this.renderOrderMobile()}
  //             </div>
  //           </div>
  //           <Button
  //             buttonClass="primary-button rp-recent-orders--button"
  //             label={'VIEW ALL'}
  //             height="100%"
  //             width="100%"
  //             action={this.viewAll}
  //           />
  //         </div>
  //       ) : (
  //           <div className="pre-login">View your recent orders in one click</div>
  //         )}
  //     </div>
  //   );
  // }

  public render() {
    // if (!this.state.isMobile) {
    //   return this.renderDesktop();
    // }
    return this.renderDesktop();
  }
}
